import { ReactNode } from 'react';
import bladeStyles from './Blade.module.css';
import styles from './BladeSection.module.css';

interface BladeSectionProps {
  title?: ReactNode;
  onClear?: () => void;
  showClear?: boolean;
  children: ReactNode;
}

const BladeSection = ({ title, onClear, showClear, children }: BladeSectionProps) => (
  <div className={bladeStyles.section}>
    {title && (
      <div className={onClear ? styles.titleRow : undefined}>
        <span className={styles.title}>{title}</span>
        {onClear && showClear && (
          <button className={styles.clearBtn} onClick={onClear}>Clear</button>
        )}
      </div>
    )}
    {children}
  </div>
);

export default BladeSection;
